import { render, staticRenderFns } from "./miniNews.vue?vue&type=template&id=572326ba&"
import script from "./miniNews.vue?vue&type=script&lang=js&"
export * from "./miniNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports